import { current } from '../../stores/backend/game';
import { isSuspended, onSuspend, suspendApp } from '../../lib/suspension';

let loading = false;
let pending: Array<() => void> = [];
onSuspend(() => {
    pending = [];
    loading = false;
});

export const beginCurrentLoad = () => {
    loading = true;
};
export const cancelCurrentLoad = () => {
    pending = [];
    loading = false;
};
export const finishCurrentLoad = () => {
    loading = false;
    const callbacks = pending;
    pending = [];
    for (const callback of callbacks) {
        if (isSuspended()) break;
        callback();
    }
};

export const deferUntilCurrentLoaded = (callback: () => void) => {
    if (loading || !current.game_sid.value) {
        pending.push(callback);
        return true;
    }
    return false;
};

export const withCurrentSession = (
    event: string,
    sessionId: number,
    callback: () => void
) => {
    if (isSuspended()) return;
    if (
        deferUntilCurrentLoaded(() =>
            withCurrentSession(event, sessionId, callback)
        )
    )
        return;
    if (
        !Number.isSafeInteger(sessionId) ||
        sessionId <= 0 ||
        sessionId !== current.game_sid.value
    ) {
        suspendApp({
            event,
            expectedSessionId: current.game_sid.value,
            receivedSessionId: sessionId,
        });
        return;
    }
    callback();
};

export const isValidPart = (part: number) =>
    Number.isInteger(part) && part > 0 && !!current.game_parts.value[part - 1];

export const compatibleCalls = (a: readonly number[], b: readonly number[]) =>
    a
        .slice(0, Math.min(a.length, b.length))
        .every((number, index) => number === b[index]);
